module.exports = __webpack_public_path__ + "static/media/Collect.56863b07.svg";